<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'App'
}
</script>

<style>
@font-face {
	font-family: 'CooperBlackStd';
	src: url('./assets/fonts/CooperBlackStd.otf') format('truetype');
}
@font-face {
	font-family: 'ooperBlackStd-Italic';
	src: url('./assets/fonts/CooperBlackStd-Italic.otf') format('truetype');
}
@font-face {
	font-family: 'arial';
	src: url('./assets/fonts/arial.ttf') format('truetype');
}
@font-face {
	font-family: 'BRLNSDB';
	src: url('./assets/fonts/BRLNSDB.TTF') format('truetype');
}
@font-face {
	font-family: 'times';
	src: url('./assets/fonts/times.ttf') format('truetype');
}
@font-face {
	font-family: 'timesbd';
	src: url('./assets/fonts/timesbd.ttf') format('truetype');
}
@font-face {
	font-family: 'timesbi';
	src: url('./assets/fonts/timesbi.ttf') format('truetype');
}
body {
	margin: 0;
	padding: 0;
}
</style>

<style scoped></style>
